// AI質問タイムラインのフィルタ条件（すべて / 学習記録 / AI質問）。
// WEB-1717: フィルタ基盤の再利用ドメイン定義（ルール ID: FILTER-01〜04）。

export const ResourceFilter = {
  all: "all",
  studyRecord: "study_record",
  aiQuestion: "ai_question",
} as const;
export type ResourceFilter =
  (typeof ResourceFilter)[keyof typeof ResourceFilter];

// 初期値（FILTER-02）
export const DEFAULT_RESOURCE_FILTER: ResourceFilter = ResourceFilter.all;

// ボタンの表示順（定義順 = すべて → 学習記録 → AI質問）
export const RESOURCE_FILTER_ORDER: ResourceFilter[] =
  Object.values(ResourceFilter);

// ボタンラベル
export const ResourceFilterLabels: Record<ResourceFilter, string> = {
  all: "すべて",
  study_record: "学習記録",
  ai_question: "AI質問",
};

// フィルタ別の空状態メッセージ（FILTER-04）
export const ResourceFilterEmptyMessages: Record<ResourceFilter, string> = {
  all: "まだ記録がありません",
  study_record: "学習記録がまだありません",
  ai_question: "AI質問記録がまだありません",
};

// 未知・未指定の値は初期値（すべて）にフォールバックする
export const toResourceFilter = (value: unknown): ResourceFilter =>
  RESOURCE_FILTER_ORDER.includes(value as ResourceFilter)
    ? (value as ResourceFilter)
    : DEFAULT_RESOURCE_FILTER;
